import React, { Component } from "react";
import { observer } from "mobx-react";

import { combineFilters } from "@formant/core/common/combineFilters";
import { IScopeFilter } from "@formant/core/model/IScopeFilter";
import { Uuid } from "@formant/core/model/Uuid";

import { deviceDetailsStore, metadataStore } from "../../../stores";
import { IMultiSelectOption, MultiSelect } from "../MultiSelect";

export interface IDeviceSelectProps {
    value: Uuid[];
    filter: IScopeFilter;
    context?: IScopeFilter;
    className?: string;
    onChange: (value: Uuid[]) => void;
}

@observer
export class DeviceSelect extends Component<IDeviceSelectProps> {
    private availableDeviceIds: Uuid[] = [];
    public render() {
        const { value, filter, context, className, onChange } = this.props;
        const combined = combineFilters(
            { ...filter, deviceIds: undefined },
            context,
        );
        const availableDeviceIds =
            metadataStore.listDeviceIds(combined) || this.availableDeviceIds;
        this.availableDeviceIds = availableDeviceIds;
        const contextDeviceIds =
            metadataStore.listDeviceIds(context || {}) || [];
        const deviceIds = [...new Set([...availableDeviceIds, ...value])];
        const options = deviceIds
            .map<IMultiSelectOption<Uuid>>(id => {
                const device = deviceDetailsStore.get(id);
                return {
                    value: id,
                    label: device ? device.name : id,
                    icon: "device",
                };
            })
            .sort((a, b) => a.label?.localeCompare(b.label || "") || 0);

        const empty = value.length === 0;

        if (empty && contextDeviceIds.length <= 1) {
            return false;
        }

        const disabled = empty && options.length <= 1;

        return (
            <MultiSelect
                value={value}
                title="Device"
                options={options}
                disabled={disabled}
                className={className}
                onChange={onChange}
            />
        );
    }
}
